import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { http, fmtGBP, fmtDate } from "@/lib/api";
import { StatusBadge, PriorityBadge } from "@/components/StatusBadge";

export default function Approvals() {
  const { data: jobs = [] } = useQuery({
    queryKey: ["jobs", "pending_approval"],
    queryFn: () => http.get("/jobs", { params: { status: "pending_approval" } }).then(r => r.data),
  });
  const { data: stores = [] } = useQuery({ queryKey: ["stores"], queryFn: () => http.get("/stores").then(r => r.data) });
  const storeMap = Object.fromEntries(stores.map(s => [s.id, s.name]));

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="overline">Queue</div>
      <h1 className="text-3xl font-heading font-semibold tracking-tight mb-6">Pending approvals</h1>
      <div className="rmms-card divide-y divide-slate-100">
        {jobs.length === 0 && <div className="px-5 py-12 text-center text-sm text-slate-500" data-testid="approvals-empty">No jobs waiting for approval.</div>}
        {jobs.map(j => (
          <Link to={`/jobs/${j.id}`} key={j.id} data-testid={`approval-row-${j.job_number}`}
            className="grid grid-cols-[auto_1fr_auto_auto] gap-4 px-5 py-3 hover:bg-slate-50 items-center transition-colors">
            <span className="font-mono-data text-[12px] text-slate-500 w-24">{j.job_number}</span>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{j.title}</div>
              <div className="text-xs text-slate-500">{storeMap[j.store_id]} · Created {fmtDate(j.created_at)}</div>
            </div>
            <div className="flex items-center gap-2">
              <PriorityBadge priority={j.priority} />
              <StatusBadge status={j.status} />
            </div>
            <span className="font-mono-data text-sm tabular-nums">{fmtGBP(j.estimated_cost)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
